import InsightsAuthGuard from './features/auth/InsightsAuthGuard'
import DashboardPage from './features/dashboard/DashboardPage'

const App = () => (
  <InsightsAuthGuard>
    <DashboardPage />
  </InsightsAuthGuard>
)

export default App
